__turbopack_context__.v({
  "dualCol": "b6c9DG_dualCol",
  "listCol": "b6c9DG_listCol",
  "pCol": "b6c9DG_pCol",
  "root": "b6c9DG_root",
  "title": "b6c9DG_title",
});
